import { Component, computed, forwardRef, input } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RadioButtonComponent } from '../radio-button/radio-button.component';
import { Option } from '../text-search/text-search.component';

@Component({
  selector: 'app-select-list',
  imports: [RadioButtonComponent, FormsModule],
  templateUrl: './select-list.component.html',
  styleUrl: './select-list.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SelectListComponent),
    },
  ],
})
export class SelectListComponent {
  readonly name = input.required<string>();
  options = input<Option[]>([]);
  valueKey = input.required<string>();

  value: Record<string, any> | undefined;
  touched = false;
  disabled = false;

  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  private readonly viewModel = computed(() => {
    return {
      name: this.name(),
      options: this.options(),
    };
  });

  get vm() {
    return this.viewModel();
  }

  writeValue(value: any): void {
    this.value = value;
  }

  selectValue(value: any): void {
    this.value = value;
    this.onChange(value);
    this.markAsTouched();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

  markAsTouched(): void {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }
}
